export default "__VITE_ASSET__BMamG60R__"